<template>
  <b-modal
    no-close-on-backdrop
    hide-footer
    size="xl"
    id="new_product"
    title="NOVO PRODUTO"
    @show="evOnShow"
    @shown="evOnShown"
  >
    <form @submit.prevent="evOnSubmit">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <LabelRequiredField label="NOME" />
          <b-input type="text" ref="autofocus" v-model="name" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
          <LabelRequiredField label="UNIDADE DE MEDIDA" />
          <select v-model="unit_of_measurement_id" class="form-control">
            <option value="">SELECIONE...</option>
            <option
              v-for="unit in units_of_measurement"
              :key="unit.id"
              :value="unit.id"
            >
              {{ `${unit.name} (${unit.abbreviation})` }}
            </option>
          </select>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
          <label>ESTOQUE MÍNIMO</label>
          <b-input type="text" v-model="minimum_stock" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
          <label>CUSTO DO PRODUTO</label>
          <b-input
            type="text"
            v-model="product_cost"
            @keyup="handleValueProductCost"
          />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
          <label>LUCRO(%)</label>
          <b-input
            type="text"
            v-on:keyup="handleValueProfit"
            v-model="profit"
          />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
          <label>VALOR DA VENDA</label>
          <b-input
            type="text"
            v-model="sale_price"
            v-on:keyup="handleValueSalePrice"
          />
        </div>
        <div class="col-md-12">
          <WarningRequiredFields />
          <ErrorsMessages :errors="errors" />
        </div>
        <div class="col-md-12 text-right">
          <v-btn :disabled="loading" type="submit" class="btn-save">
            <i class="fas fa-save mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "SALVAR" }}
          </v-btn>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import toast from "../../lib/ToastNotification";
import api from "../../services/api";

import WarningRequiredFields from "../Components/WarningRequiredFields";
import LabelRequiredField from "../Components/LabelRequiredField";
import ErrorsMessages from "../Components/ErrorsMessages";

import {
  formatPrice,
  formatValueOnKeyUp,
  formatValueToOnlyNumber,
  formatValueToPercentage,
} from "../../lib/format";

export default {
  name: "NewProduct",
  components: {
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data: () => ({
    errors: [],
    loading: false,

    units_of_measurement: [],

    name: "",
    unit_of_measurement_id: "",
    minimum_stock: "",
    product_cost: "",
    profit: "",
    sale_price: "",
  }),
  methods: {
    /** imports */

    /** eventos */
    async evOnShow() {
      this.errors = [];
      this.loading = false;

      this.units_of_measurement = [];

      this.name = "";
      this.unit_of_measurement_id = "";
      this.minimum_stock = "";
      this.product_cost = "";
      this.profit = "";
      this.sale_price = "";

      await this.getUnitsOfMeasurement();
    },
    async evOnShown() {
      this.$refs.autofocus.focus();
    },
    async evOnSubmit() {
      try {
        this.loading = true;

        const data = {
          unit_of_measurement_id: this.unit_of_measurement_id,
          name: this.name,
          minimum_stock: this.minimum_stock,
          product_cost: this.product_cost,
          profit: this.profit,
          sale_price: this.sale_price,
        };
        const response = await api.post("/rest-home/product/create", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          toast(message, "success");
          this.$bvModal.hide("new_product");
          this.$emit("created");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    /** parsers */
    async getUnitsOfMeasurement() {
      try {
        this.loading = true;

        const response = await api.get("/units-of-measurement/from-products");
        const { error, errors, units_of_measurement } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.units_of_measurement = units_of_measurement;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    /** methods */
    handleValueProfit: function (e) {
      var profit = formatValueToPercentage(e.target.value);
      if (profit) {
        var current = formatValueToOnlyNumber(this.product_cost);
        var percentage = profit * current;
        var sale_price = percentage / 100;
        sale_price = parseFloat(sale_price) + parseFloat(current);
        this.sale_price = formatPrice(sale_price);
      } else {
        this.sale_price = formatPrice(0);
      }
    },
    handleValueProductCost: function (e) {
      this.product_cost = formatValueOnKeyUp(e.target.value);

      var current = formatValueToOnlyNumber(e.target.value);
      var sale_price = formatValueToOnlyNumber(this.sale_price);

      if (parseInt(current) <= parseInt(sale_price)) {
        var percentage = parseFloat(sale_price - current);
        var profit = percentage * 100;
        profit = profit / current;
        profit = String(profit);
        this.profit = profit.replace(".", ",");
      }
    },
    handleValueSalePrice: function (e) {
      this.sale_price = formatValueOnKeyUp(e.target.value);

      var current = formatValueToOnlyNumber(this.product_cost);
      var sale_price = formatValueToOnlyNumber(e.target.value);

      if (parseInt(current) <= parseInt(sale_price)) {
        var percentage = parseFloat(sale_price - current);
        var profit = percentage * 100;
        profit = profit / current;
        profit = String(profit);
        this.profit = profit.replace(".", ",");
      }
    },
  },
};
</script>

<style></style>
